var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('RecapDocumentsNumber'),_c('div',{staticClass:"app-container"},_vm._l((this.$store.getters['documents/get']),function(document){return _c('DocumentCard',{key:document.id_file,attrs:{"document":document}})}),1),_c('DocumentPreview')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }